import { Search } from "lucide-react";
import { useShop } from "../../context/ShopContext";

export default function SearchBar(){

const{

search,

setSearch

}=useShop();

return(

<div className="relative">

<Search
size={18}
className="absolute left-5 top-1/2 -translate-y-1/2 text-gray-400"
/>

<input

value={search}

onChange={(e)=>setSearch(e.target.value)}

placeholder="Search books, coffee, apparel..."

className="w-full rounded-full border px-14 py-4 focus:border-[#6B8E5F] outline-none"

/>

</div>

)

}